import _typeof from 'babel-runtime/helpers/typeof';
var render = function render() {
        var _vm = this,
            _c = _vm._self._c,
            _setup = _vm._self._setupProxy;return _c('div', { staticClass: "pt-button", style: _vm.buttonAttr }, [_c('el-button', { attrs: { "type": "text", "disabled": _vm.disabled }, on: { "click": _vm.handleClick } }, [_vm.icon && _typeof(_vm.icon) === 'object' ? _c(_vm.icon, { tag: "component" }) : _vm.icon ? _c('svg-icon', { staticClass: "icon", class: {
                        'is-disabled': _vm.disabled
                }, attrs: { "size": _vm.size, "icon-class": _vm.icon } }) : _c('span', { staticClass: "label" }, [_vm._v(_vm._s(_vm.label))])], 1)], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };